import React from 'react';
import { styled } from '@mui/material/styles';
import Tabs from '@mui/material/Tabs';

const StyledTabs = styled(Tabs)(({ theme }) => ({
}));

export default function CustomTabs(props) {

    const { children, ...rest } = props;

    return (
        <StyledTabs
            {...rest}
        >
            {children}
        </StyledTabs>
    );
}
